// layouts/MyMasterLayout.js
import React, { useState } from "react";
import MentorSidebar from "./../../screens/mentor/mentordashboard/Sidebar";
import MentorHeader from "./../../screens/mentor/mentordashboard/Header";
import "./../../assets/css/layouts/Masterlayout.css";

const SIDEBAR_EXPANDED = "260px";
const SIDEBAR_COLLAPSED = "68px";

const MyMasterLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  // ── localStorage se mentor data ──
  const mentorData = JSON.parse(localStorage.getItem("mentorData") || "{}");
  const firstname = mentorData?.firstname || "";
  const lastname = mentorData?.lastname || "";
  const email = mentorData?.email || "";
  const fullName =
    firstname && lastname
      ? `${firstname} ${lastname}`
      : firstname || email.split("@")[0] || "Mentor";

  return (
    <div
      className="mentor-layout"
      style={{
        "--current-msb-w": collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_EXPANDED,
      }}
    >
      {/* ── SIDEBAR — fixed, left ── */}
      <MentorSidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((p) => !p)}
        mentorName={fullName}
        mentorEmail={email}
        mentorTitle="Senior Mentor"
      />

      {/* ── RIGHT COLUMN — header + content ── */}
      <div className="mentor-content-col">
        {/* Header — full width of content col */}
        <MentorHeader mentorName={fullName} mentorEmail={email} />

        {/* Scrollable content */}
        <main className="mentor-content-area">{children}</main>
      </div>
    </div>
  );
};

export default MyMasterLayout;
